<template>
    <b-form-input v-model="searchText" type="search" placeholder="Search" debounce="300" />
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'ModalImportSearch'
})
export default class ModalImportSearch extends Vue {
    searchText: string | null = null;

    @Watch('searchText')
    onSearchTextChange() {
        this.$emit('search-text-change', this.searchText);
    }
}
</script>
